import React from "react";

export default function ProductSkeleton() {
    return (
        <div className="row">
            {/* Left: Image Skeleton */}
            <div className="col-md-6 d-flex justify-content-center align-items-center">
                <div className="skeleton-box w-100 " style={{height:'70vh'}}></div>
            </div>

            {/* Right: Text Skeleton */}
            <div className="col-md-6">
                <div className="skeleton-box mt-2 w-75 mb-3" style={{ height: "30px" }}></div>
                <div className="skeleton-box w-100 mb-3" style={{ height: "60px" }}></div>
                <div className="skeleton-box w-50 mb-3" style={{ height: "20px" }}></div>
                <div className="skeleton-box w-100 mb-3" style={{ height: "40px" }}></div>
            </div>
        </div>
    );
}
